import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Input from 'components/Input';
import styles from './RadioInput.module.scss';

function RadioInput({
  children,
  isChecked,
  value,
  onChange,
  labelClassName,
  inputClassName,
  childrenClassName,
  ...remainingProps
}) {
  return (
    <label className={classNames(styles.root, labelClassName)}>
      <Input
        type="radio"
        checked={isChecked}
        value={value}
        onChange={onChange}
        className={inputClassName}
        {...remainingProps}
      />
      <span className={classNames('m-l-xxs p-b-xxs', childrenClassName)}>
        {children}
      </span>
    </label>
  );
}

RadioInput.propTypes = {
  children: PropTypes.node,
  isChecked: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  childrenClassName: PropTypes.string,
};

export default RadioInput;
